import React from 'react';
import Icon from "../../../components/core_component/icon";
import { Button, PrimaryCta } from '../../../components';

const RefreshDataBanner = ({ onRefresh, isLoading, lastGenerated, disabled, tooltip, nextRefreshIn, isReportGenerated = true }) => {
    return (
        <div className="refresh-data-banner">
            <div className="refresh-banner-left">
                <div className="refresh-icon-wrapper">
                    <Icon iconName="SyncBlueIcon" color="#1977F2" width="20" height="20" />
                </div>
                <div className="refresh-text-content">
                    {!isReportGenerated ? (
                        <h3>Report not generated</h3>
                    ) : (
                        <h3>Refresh data manually</h3>
                    )}

                    <p>
                        {!isReportGenerated
                            ? "Please generate the report to view the latest analytics data."
                            : "Request the latest statistics for all influencer's media, which is available every 1 hour."
                        }
                    </p>
                    {isReportGenerated && lastGenerated && (
                        <span className="last-generated-refresh">Last generated: {lastGenerated}</span>
                    )}
                </div>
            </div>
            <div className="refresh-banner-right" data-tooltip={tooltip}>
                <div className="refresh-cta-wrapper" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                    <Button
                        variant="secondary"
                        icon={!isLoading ? "SyncBlueIconSmall" : undefined}
                        isLoading={isLoading}
                        disabled={disabled}
                        onClick={!disabled && !isLoading ? onRefresh : undefined}
                    >
                        {!isReportGenerated ? "Generate Report" : "Refresh Now"}
                    </Button>
                    {/* <PrimaryCta
                        invertSmall
                        text={!isReportGenerated ? "Generate Report" : "Refresh Now"}
                        iconName={isLoading ? "Loading" : "SyncBlueIcon"}
                        iconPosition="left"
                        padding="0px 12px"
                        fontSize="font_size_small"
                        onClick={!disabled && !isLoading ? onRefresh : undefined}
                        isLoading={isLoading}
                        disabled={isLoading || (isReportGenerated && disabled)}
                        style={{
                            opacity: (isLoading || (isReportGenerated && disabled)) ? 0.6 : 1,
                            cursor: (isLoading || (isReportGenerated && disabled)) ? 'not-allowed' : 'pointer',
                        }}
                    /> */}
                    {disabled && nextRefreshIn > 0 && isReportGenerated && (
                        <span className="next-refresh-timer" style={{ fontSize: '12px', color: '#6a6a6a' }}>
                            Next refresh in {nextRefreshIn} mins
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RefreshDataBanner;
